import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">
          {t("categories.title")}
        </h2>
        <p className="mt-3 text-sm text-foreground-600 md:text-base">
          {t("categories.subtitle")}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {categories.map((c) => (
          <a
            key={c.id}
            href={c.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-white transition-transform duration-200 hover:-translate-y-1 cursor-pointer"
          >
            <div className="relative h-40 w-full overflow-hidden md:h-44">
              <img
                src={c.image}
                alt={t(`categories.${c.id}`)}
                title={`${t("brand.name")} ${t(`categories.${c.id}`)}`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 px-4 py-3">
              <span className="text-sm font-semibold text-foreground-900">
                {t(`categories.${c.id}`)}
              </span>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-500 transition-colors group-hover:bg-primary-500 group-hover:text-white">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}